module.exports = "<app-company-registration-list></app-company-registration-list>"